export default __webpack_public_path__ + "static/media/brand.0c697a3c.png";